import React, { useMemo } from "react";
import BaseNode from "./BaseNode";
import type { HandleProps, NodeProps } from "./types";
import { Position } from "@xyflow/react";
import RichInput from "../RichInput";
import { TextIcon } from "lucide-react";
import FormField from "../FormField";
import useNodeField from "@/hooks/useNodeField";
import useHandles from "@/hooks/useHandles";

interface TextNodeData {
  text?: string;
}

export const TextNode: React.FC<NodeProps> = ({ id, data, ...props }) => {
  const [text, setText] = useNodeField<string>(
    id,
    "text",
    (data as TextNodeData)?.text || "",
  );

  const defaultHandles: HandleProps[] = useMemo(
    () => [
      {
        type: "source",
        position: Position.Right,
        id: "output",
        label: "output",
      },
    ],
    [],
  );

  const { handles, onVariablesChange } = useHandles();

  const allHandles = useMemo(() => {
    return [...defaultHandles, ...handles];
  }, [defaultHandles, handles]);

  return (
    <BaseNode
      id={id}
      data={data}
      title="Text"
      icon={<TextIcon size={16} />}
      handles={allHandles}
      className="w-[250px]"
      {...props}
    >
      <FormField label="Text">
        <RichInput
          id={`${id}-Text`}
          value={text}
          onChange={(value) => setText(value)}
          onVariablesChange={onVariablesChange}
          placeholder="Enter text with {{variables}}"
        />
      </FormField>
    </BaseNode>
  );
};

export default TextNode;
